import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const propTypes = {
  children: PropTypes.object.isRequired,
  to: PropTypes.string.isRequired,
};

const Item = (props) => (
  <Link
    to={props.to}
    activeClassName="active"
    className="item"
  >
    {props.children}
  </Link>
);

Item.propTypes = propTypes;

export default Item;



/** WEBPACK FOOTER **
 ** ./src/components/layout/nav/item/Item.js
 **/